import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a027ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "success-box__title" }, "VERIFIQUE SEU E-MAIL", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "success-box__description" }, " Enviamos as instruções de recuperação de senha para o seu e-mail. ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Voltar para tela inicial")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_router_link, {
      to: { name: 'home' },
      class: "success-box__link"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}